export class AssignationSalesCountPerYearMonthView {
    count: number
    yearMonth: string;

    constructor(data?: any) {
        this.count = data?.count ?? 0;
        this.yearMonth = data?.yearMonth ?? "";
    }

}